export default "__VITE_ASSET__babd86e7__"